
export const FETCH_FLOATINFO = 'FETCH_FLOATINFO';

